export enum TestGroup {
    Warranty_Redesign = 't_warranty',
    WhatsCovered_Redesign = 't_whatscovered'
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/models/testGroups.ts